import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { DashboardPreferences } = protos;

export function fetch(businessId: number): ApiAction {
  return {
    TockApi: {
      getProto: '/dashboard/preferences',
      type: AppConstants.DASHBOARD_PREFERENCES_FETCH,
      context: { businessId },
    },
  };
}

export function save(preferences: dashboard.DashboardPreferences, businessId: number): ApiAction {
  const request = DashboardPreferences.fromObject(preferences);

  return {
    TockApi: {
      postProto: '/dashboard/preferences',
      type: AppConstants.DASHBOARD_PREFERENCES_SAVE,
      request,
      context: { businessId },
    },
  };
}
